import { render, staticRenderFns } from "./ExercismMatchingBrackets.vue?vue&type=template&id=90680c10&"
import script from "./ExercismMatchingBrackets.vue?vue&type=script&lang=js&"
export * from "./ExercismMatchingBrackets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports